<template>
  <div>
    <div
      v-if="authenticated"
      class="text-right position-absolute"
      style="top:10px; right: 10px; z-index: 992;"
    >
      <b-dropdown
        id="dropdown-1"
        right
        toggle-class="text-decoration-none"
        no-caret
        class
        variant="outline-info"
      >
        <template v-slot:button-content>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="feather feather-settings"
          >
            <circle cx="12" cy="12" r="3" />
            <path
              d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"
            />
          </svg>
        </template>
        <b-dropdown-item href="/dashboard" target="_blank">Dashboard</b-dropdown-item>
        <b-dropdown-item href="/factorydetails" target="_blank">Factory details dashboard</b-dropdown-item>
        <b-dropdown-item href="/fullmap" target="_blank">Factory & Growers Location</b-dropdown-item>
        <b-dropdown-item href="/preview" target="_blank">View Dashboard History</b-dropdown-item>
        <b-dropdown-item href="#" @click.prevent="logout">Sign Out</b-dropdown-item>
      </b-dropdown>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  computed: {
    ...mapGetters({
      authenticated: "auth/authenticated",
      user: "auth/user"
    })
  },

  methods: {
    ...mapActions({
      logoutAction: "auth/logout"
    }),

    logout() {
      this.logoutAction().then(() => {
        this.$router.replace({
          name: "login"
        });
      });
    }
  }
};
</script>
